import React from 'react';
import Banner from '@ingka/banner';
import { useGetAppConfigQuery } from '@/redux/back-dashboard-api';

export const MaintenanceBanner = () => {
  const { data } = useGetAppConfigQuery(undefined);

  if (!data?.appConfig?.maintenanceStatus?.enabled) return null;

  const { text, dismissable, emergency } = data.appConfig.maintenanceStatus;

  return (
    <Banner
      body={<span>{text}</span>}
      dismissable={dismissable ?? undefined}
      dismissHandler={() => {}}
      emergency={emergency ?? undefined}
    />
  );
};
